export default {
    jobsForProof: [],
    jobsForProofLoading: false,
}